module.exports = __webpack_public_path__ + "img/portfolio_2.0ecffd31.jpg";